export function isSome<T>(val: T | undefined | null): val is T {
  return val !== undefined && val !== null;
}

export function sleep(time: number, fail?: boolean): Promise<void> {
  return new Promise((resolve, reject) => {
    const callback = fail ? reject : resolve;
    setTimeout(callback, time);
  });
}
